module.exports = __webpack_public_path__ + "static/media/more_choices.5b2aebc8.svg";